import React from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ListItemIcon, ListItemText, Divider, Box, Tooltip, ListItemButton } from '@mui/material';
import {
  CreateOutlined,
  Event, HomeOutlined, PersonOutlineOutlined,
  ShoppingCartOutlined,
  CloseOutlined
} from '@mui/icons-material';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const collapsedTooltipSx = {
  tooltip: {
    sx: {
      backgroundColor: '#ffffff',
      color: '#9496aa',
      fontSize: '12px',
      fontFamily: 'Bricolage Grotesque',
      textTransform: 'uppercase',
      fontWeight: 600,
      boxShadow: '0px 8px 24px rgba(11, 0, 98, 0.12), 0px 2px 8px rgba(0,0,0,0.08)',
      border: '1px solid rgba(75, 77, 99, 0.1)',
      borderRadius: '6px',
      px: 1.5,
      py: 0.75,
    }
  },
};

const GeneralMenu = ({ isAuthenticated, unreadCount, closeMenus, loginWithRedirect, logoutWithRedirect, isMobile, collapse }) => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    return currentPath.includes(path);
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      gap: "50px",
      width: '100%',
      alignItems: collapse ? 'center' : 'flex-start',
    }}>
      <Box sx={{ marginTop: '20px', width: '100%' }}>
        <Tooltip title={collapse ? t("navbar.home") : ""} placement="right" componentsProps={collapsedTooltipSx}>
          <ListItemButton
            component={Link}
            onClick={() => { if (isMobile) closeMenus(); }}
            to="/"
            sx={{ color: "#4B4D63", textDecoration: "none", justifyContent: collapse ? 'center' : 'flex-start', px: collapse ? 0 : undefined }}
            className="drawer-item"
          >
            <ListItemIcon sx={{ minWidth: collapse ? 0 : "40px", justifyContent: 'center' }}>
              <HomeOutlined style={{ color: "#4B4D63" }} />
            </ListItemIcon>
            {!collapse && (
              <ListItemText primary={t("navbar.home")}
                primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/`) ? 600 : 400 }
                }} />
            )}
          </ListItemButton>
        </Tooltip>
        <Tooltip title={collapse ? t("navbar.createEvents") : ""} placement="right" componentsProps={collapsedTooltipSx}>
          <ListItemButton
            component={Link}
            to="/creaeventos"
            onClick={() => { if (isMobile) closeMenus(); }}
            sx={{ color: "#4b4d63", textDecoration: "none", justifyContent: collapse ? 'center' : 'flex-start', px: collapse ? 0 : undefined }}
            className="drawer-item"
          >
            <ListItemIcon sx={{ minWidth: collapse ? 0 : "40px", justifyContent: 'center' }}>
              <CreateOutlined style={{ color: "#4B4D63" }} />
            </ListItemIcon>
            {!collapse && (
              <ListItemText primary={t("navbar.createEvents")} primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: { fontSize: "14px", color: "#4B4D63", fontWeight: currentPath === `/creaeventos` ? 600 : 400 }
              }} />
            )}
          </ListItemButton>
        </Tooltip>
        {isAuthenticated && (
          <>
            <Tooltip title={collapse ? t("navbar.myEvents") : ""} placement="right" componentsProps={collapsedTooltipSx}>
              <ListItemButton
                component={Link}
                to="/eventos"
                onClick={() => { if (isMobile) closeMenus(); }}
                sx={{ color: "#4B4D63", textDecoration: "none", justifyContent: collapse ? 'center' : 'flex-start', px: collapse ? 0 : undefined }}
                className="drawer-item"
              >
                <ListItemIcon sx={{ minWidth: collapse ? 0 : "40px", justifyContent: 'center' }}>
                  <Event style={{ color: "#4B4D63" }} />
                </ListItemIcon>
                {!collapse && (
                  <ListItemText primary={t("navbar.myEvents")} primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos`) ? 600 : 400 }
                  }} />
                )}
              </ListItemButton>
            </Tooltip>
            <Tooltip title={collapse ? "Mis compras" : ""} placement="right" componentsProps={collapsedTooltipSx}>
              <ListItemButton
                component={Link}
                to="/mis-compras"
                onClick={() => { if (isMobile) closeMenus(); }}
                sx={{ color: "#4b4d63", textDecoration: "none", justifyContent: collapse ? 'center' : 'flex-start', px: collapse ? 0 : undefined }}
                className="drawer-item"
              >
                <ListItemIcon sx={{ minWidth: collapse ? 0 : "40px", justifyContent: 'center' }}>
                  <ShoppingCartOutlined style={{ color: "#4b4d63" }} />
                </ListItemIcon>
                {!collapse && (
                  <ListItemText primary="Mis compras" primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/mis-compras`) ? 600 : 400 }
                  }} />
                )}
              </ListItemButton>
            </Tooltip>
            <Tooltip title={collapse ? t("navbar.profile") : ""} placement="right" componentsProps={collapsedTooltipSx}>
              <ListItemButton
                component={Link}
                to="/profile"
                onClick={() => { if (isMobile) closeMenus(); }}
                sx={{ color: "#4b4d63", textDecoration: "none", justifyContent: collapse ? 'center' : 'flex-start', px: collapse ? 0 : undefined }}
                className="drawer-item"
              >
                <ListItemIcon sx={{ minWidth: collapse ? 0 : "40px", justifyContent: 'center' }}>
                  <PersonOutlineOutlined style={{ color: "#4b4d63" }} />
                </ListItemIcon>
                {!collapse && (
                  <ListItemText primary={t("navbar.profile")} primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/profile`) ? 600 : 400 }
                  }} />
                )}
              </ListItemButton>
            </Tooltip>
          </>
        )}
      </Box>

      {!collapse &&
        <>
          <Box sx={{ marginTop: 'auto', width: '100%' }}>
            <Divider style={{ backgroundColor: '#4b4d63', width: '100%', margin: '10px 0' }} />

            <ListItemButton
              onClick={() => {
                if (isMobile) {
                  if (typeof window !== "undefined") {
                    window.localStorage.setItem("drawerClosedManually", "true");
                  }
                }
                closeMenus();
              }}
              sx={{
                color: "#4B4D63",
                textDecoration: "none",
                justifyContent: "center",
                marginTop: "10px",
                cursor: "pointer",
                px: collapse ? 0 : undefined,
              }}
              className="drawer-item"
            >
              <ListItemIcon sx={{ minWidth: collapse ? 0 : "40px", justifyContent: 'center' }}>
                <CloseOutlined style={{ color: "#4b4d63" }} />
              </ListItemIcon>
              {!collapse && (
                <ListItemText primary="Ocultar menú" primaryTypographyProps={{
                  fontFamily: "Bricolage Grotesque",
                  sx: { fontSize: "14px", color: "#4B4D63" }
                }} />
              )}
            </ListItemButton>
          </Box>
        </>
      }
    </Box>
  );
};

export default GeneralMenu;